import { SnowplowService } from 'wanderu-service-analytics';

export const sendEvent = (button) => SnowplowService.fireStructuredEvent({
    action: 'click',
    category: 'native_app_funnel',
    label: 'tapped_app_icon',
    property: {
        button,
    },
});
